(function() {
    'use strict';

    a3_cabin_reports.controller('ReleaseSignatureModalCtrl', ReleaseSignatureModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name SignatureModalCtrl
     * @description 
     * Shows Show Signature 
     * @ngInject
     */

    function ReleaseSignatureModalCtrl($scope, $routeParams, CourseFactory, $uibModalInstance, courseId, isGround, confirmationMsg, requiresInstructorSignature, trainees, submitRelease){
        $scope.close = close;
        $scope.submit = submit;
        $scope.confirm = confirm;
        $scope.confirmAircraft = confirmAircraft;

        $scope.errorMessage = "";
        $scope.successMessage = "";
        $scope.responseText = null;
        $scope.responseHasErrors = null;
        $scope.success = false;
        $scope.isLoading = false;

        $scope.formData = {};
               
        $scope.requiredSignature = requiresInstructorSignature;

        $scope.isConfirmed = true;
        $scope.finalPendigArVis = [];
        
        if(isGround && hasPendingAircraftVisits()) {
            $scope.aircraftVisits = true;
        }
        else if(confirmationMsg){
            $scope.confirmationMsg = confirmationMsg;
            $scope.isConfirmed = false;
        }
        else{
            if(!requiresInstructorSignature){ //if signature isn't required continue with submit 
                $scope.isLoading = true;
                submit();
            }
        }

        function hasPendingAircraftVisits() {
            var released = trainees.filter(x => x.RadioModel)
            var pendingVisits = released.some(x => x.pendingAircrafts && x.pendingAircrafts.length > 0);

            if(pendingVisits){        
                var maxLength = 0;
                released.forEach(function(trainee){
                    if(trainee.pendingAircrafts.length > maxLength){
                        var maxList = trainee.pendingAircrafts;
                        maxLength = maxList.length;      
                        $scope.finalPendigArVis = trainee.pendingAircrafts;                                      
                    }               
                });
            }
            return pendingVisits;
        }

        function confirm(){
            $scope.isConfirmed = true;
            if(!requiresInstructorSignature){ //if signature isn't required continue with submit 
                $scope.isLoading = true;
                submit();
            }
        }

        function confirmAircraft() {
            $scope.aircraftVisits = false;
            if(confirmationMsg){
                $scope.confirmationMsg = confirmationMsg;
                $scope.isConfirmed = false;
            }        
        }

        function submit(){
            $scope.errorMessage = "";
            $scope.successMessage = "";
           
            $scope.isLoading = true;
            $scope.success = false;

            var signaturePassword = $scope.formData.password;
            if(!signaturePassword && requiresInstructorSignature){
                $scope.isLoading = false;
                $scope.errorMessage = "Signature is required. Please enter your password.";
            }else{

                submitRelease(signaturePassword).then(function(data){
                    $scope.isLoading = false;
                    var errorMessage = data.data.errorMessage;

                    $scope.successMessage = "Training has been submitted."

                    //always show errorMessage even if success is true
                    if(errorMessage && errorMessage.length > 0){
                        $scope.errorMessage = errorMessage;

                        //not Release Trainees
                        var responseTrainees = data.data.data.data;
                        var responseTraineeCrewIds = responseTrainees.map(function(trainee){return trainee.CrewId});
                        $scope.traineeInfo = trainees.filter(x => responseTraineeCrewIds.includes(x.CrewId));
                    }
                    else{
                        $scope.errorMessage = null;
                    }

                    CourseFactory.setCourseOutdated(courseId);
                    $scope.success = true;
                }).catch(function(data){
                    $scope.isLoading = false;
                    if(data.data && data.data.errorMessage){
                        $scope.errorMessage = data.data.errorMessage;
                    }
                    else{
                        $scope.errorMessage = "Failed to save Training Session";
                    }
                });    
            }

            // clear password
		    $scope.formData.password = "";
        }

        /**
         * Close the modal
         * @memberof SignModalCtrl
         */
        function close(){
            var result = {
                "success" : $scope.success
            };
            $uibModalInstance.close(result);
        }
    }
})();